import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Main2025() {
  const handleDownload1 = () => {
    window.open(
      "assets/2025/issue1/1. Problems of congestion in Urban Housing - James LT Thanga, Tuanmuansanga, Ashley Lalremrua.pdf",
      "_blank",
    );
  };
  const handleDownload2 = () => {
    window.open(
      "assets/2025/issue1/2. Marginalized Motherhood A Sociological Study of HIV Positive Female Sex Workers in Urban M.pdf",
      "_blank",
    );
  };
  const handleDownload3 = () => {
    window.open(
      "assets/2025/issue1/3. The growth of enterprises in Mizoram - MS Dawngliana Hnamte.pdf",
      "_blank",
    );
  };
  const handleDownload4 = () => {
    window.open(
      "assets/2025/issue1/4. Farmer Producer Organisations (FPOs) in Mizoram A Case Study - Lalengkima.pdf",
      "_blank",
    );
  };
  const handleDownload5 = () => {
    window.open(
      "assets/2025/issue1/5. The Impact of Roads on Economic Development of Rural Mizoram - Lianhmingthanga.pdf",
      "_blank",
    );
  };
  const handleDownload6 = () => {
    window.open(
      "assets/2025/issue1/6. A Brief Inquiry of Intergenerational Mobility Among the White-Collar Workforce in Mizoram .pdf",
      "_blank",
    );
  };
  const handleDownload7 = () => {
    window.open(
      "assets/2025/issue1/7. Impact of Unified Payments Interface (Upi) on Impulsive Buying Behaviour In Falkawn Villag.pdf",
      "_blank",
    );
  };
  const handleDownload8 = () => {
    window.open(
      "assets/2025/issue1/8. Statistics At a Glance.pdf",
      "_blank",
    );
  };
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <meta
        name="description"
        content="The Problem of Congestion in Urban Housing in North-East India"
      />
      <meta
        name="description"
        content="Marginalized Motherhood: A Sociological Study of HIV-Positive
Female Sex Workers in Urban Mizoram"
      />
      <meta name="description" content="The Growth of Enterprises in Mizoram" />
      <meta
        name="description"
        content="Farmer Producer Organisations (FPOs) in Mizoram: A Case Study"
      />
      <meta
        name="description"
        content="The Impact of Roads on Economic Development of Rural Mizoram"
      />
      <meta
        name="description"
        content="A Brief Inquiry of Intergenerational Mobility Among the White-Collar
Workforce in Mizoramr"
      />
      <meta
        name="description"
        content="Impact of Unified Payments Interface (UPI) on Impulsive Buying
Behaviour In Falkawn Village, Aizawl "
      />
      <meta name="description" content="Statistics At a Glance" />
      <main className=" h-full justify-center items-center flex mx-20">
        <div className="flex flex-col-reverse lg:flex-row  justify-center items-center">
          {/* Book Cover */}
          <div className=" mr-20 sm:mt-0 md:mt-20 mt-20 flex flex-col justify-center items-center">
            <img className="h-96 w-60" src="mea.webp" />
            <div className=" text-center font-semibold">ISSN 2581-7523</div>
          </div>
          {/* Main Page */}
          <div className="">
            <div className="">
              <div className=" font-bold text-xl">Mizoram Economic Review</div>
              <div className="text-sm">Volume VIII, Issue 1, June 2025</div>
              <div className="text-sm">ISSN 2581-7523</div>
            </div>

            {/* Content */}
            <div className="mt-10 grid grid-row-1 gap-6">
              <button className="text-left" onClick={handleDownload1}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                 Problems of congestion in Urban Housing
                </div>
                <div className="text-sm text-green-600">
                 James LT Thanga, Tuanmuansanga, Ashley Lalremrua
                </div>
              </button>
              <button className="text-left" onClick={handleDownload2}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Marginalized Motherhood A Sociological Study of HIV Positive Female Sex Workers in Urban Mizoram
                </div>
                <div className="text-sm text-green-600">
                 R. Laldampuii
                </div>
              </button>
              <button className="text-left" onClick={handleDownload3}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  The Growth of Enterprises in Mizoram
                </div>
                <div className="text-sm text-green-600">M.S. Dawngliana Hnamte</div>
              </button>
              <button className="text-left" onClick={handleDownload4}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                 Farmer Producer Organisations (FPOs) in Mizoram: A Case Study
                </div>
                <div className="text-sm text-green-600">Lalengkima</div>
              </button>
              <button className="text-left" onClick={handleDownload5}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                The Impact of Roads on Economic Development of Rural Mizoram
                </div>
                <div className="text-sm text-green-600">
                  Lianhmingthanga
                </div>
              </button>
              <button className="text-left" onClick={handleDownload6}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                 A Brief Inquiry of Intergenerational Mobility Among the White-Collar Workforce in Mizoram
                </div>
                <div className="text-sm text-green-600">Lalrinkima & TC Lalpekhlui</div>
              </button>
              <button className="text-left" onClick={handleDownload7}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                 Impact of Unified Payments Interface (UPI) on Impulsive Buying Behaviour In Falkawn Village, Aizawl
                </div>
                <div className="text-sm text-green-600">
                 Clara Lalpekhlui
                </div>
              </button>
               <button className="text-left" onClick={handleDownload8}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  STATISTICS AT A GLANCE
                </div>
                <div className="text-sm text-green-600">
                 Mizoram Budget 2025-26
                </div>
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
